@if (authService.currentUser()) {
  <button class="text-white" (click)="menuStateService.toggleMobileTabNavi()">
    <i class="pi pi-bars !text-xl"></i>
  </button>
}

<div
  class="relative z-40 transition-all duration-300 ease-in-out"
  [ngClass]="{
    'pointer-events-none invisible opacity-0': !menuStateService.mobileTabNaviOpen(),
    'visible opacity-100': menuStateService.mobileTabNaviOpen(),
  }">
  <div role="none" class="fixed inset-0 bg-[rgba(0,0,0,0.2)]" (click)="menuStateService.toggleMobileTabNavi(false)"></div>
  <div
    class="fixed bottom-0 left-0 top-0 z-50 w-full transform bg-black text-white transition-all duration-300 ease-in-out md:w-1/2"
    [ngClass]="{
      '-translate-x-full': !menuStateService.mobileTabNaviOpen(),
      'translate-x-0': menuStateService.mobileTabNaviOpen(),
    }">
    <div class="flex h-full flex-col pt-6">
      <!-- Header -->
      <div class="flex items-center justify-between px-4">
        <a routerLink="chat" (click)="menuStateService.toggleMobileTabNavi(false)">
          <span class="icon-qira-logo text-3xl"></span>
        </a>

        <p-button
          size="small"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          icon="pi pi-times-circle"
          class="[&_.p-button-icon]:text-zinc-200"
          (onClick)="menuStateService.toggleMobileTabNavi(false)" />
      </div>

      <h5 class="text-md mt-16 px-4">{{ 'chat.tabList' | transloco }}</h5>

      <div class="flex flex-1 flex-col overflow-hidden">
        <!-- Tab links -->
        <app-scroll-container [black]="true" class="flex-1">
          <div class="flex flex-col justify-between px-4 py-4">
            <div class="mt-4 flex flex-col space-y-4">
              @for (tab of tabService.tabs(); track tab._id) {
                <div
                  class="flex items-center justify-between truncate rounded-md pb-4 pl-4 pr-8 pt-5"
                  [ngClass]="{
                    'bg-stone-800': tab._id === tabService.activeTab()?._id,
                  }">
                  <button (click)="switchTab(tab)" class="flex-1 overflow-hidden">
                    <app-tab-button [tab]="tab" [hideCloseButton]="true" [darkMode]="true" contentClass="text-white" />
                  </button>

                  <app-close-tab-button
                    [tab]="tab"
                    class="pl-4"
                    iconClass="!w-4 !h-4"
                    (onClose)="menuStateService.toggleMobileTabNavi(false)"
                    (onClose)="onTabClose()" />
                </div>
              }
            </div>
          </div>
        </app-scroll-container>

        <app-open-vehicle-selection-button type="white-button" class="block px-4 py-6" (onClick)="menuStateService.toggleMobileTabNavi(false)" />
      </div>
    </div>
  </div>
</div>
